<script lang="ts" setup>
defineProps<{
  coverage: number,
  title?: string,
  subtitle?: string,
  percentageBar?: boolean,
}>();
</script>

<template>
  <div class="flex flex-col items-start text-gray-600 md:pl-8">
    <div><p>{{ title }}</p></div>

    <div><p class="text-blue font-bold text-3xl">{{coverage}}%</p></div>

    <div v-if="!percentageBar"><p>{{ subtitle }}</p></div>
    <div v-else class="overflow-hidden h-4 text-xs flex rounded bg-blue-200 w-full">
      <div :style="`width: ${coverage}%`" class=" shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue"></div>
    </div>
  </div>
</template>
